import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

export function provideTranslocoScopeFactoryEditProjectRefs(): Provider {
  return provideTranslocoScope({
    scope: 'shared-factory-edit-project-references',
    alias: 'factoryEditProjectRefs',
    loader: i18nLoader,
  });
}
